import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * PageHead Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Background Image
     */
    @Prop({ type: Object }) img!: { [k: string]: any };

    /**
     * Background Color
     * In case of missing background image
     */
    @Prop({ default: '#FFFFFF' }) bgColor!: string;

    /**
     * Height of the page head
     */
    @Prop({ default: '400px' }) height!: string;

    /**
     * Add overlay to the page head bg
     */
    @Prop({ type: Boolean }) overlay!: boolean;

    /**
     * Title
     */
    @Prop() title!: string;

    /**
     * Subtitle
     */
    @Prop() subtitle!: string;

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;
}
